export function HandIcon(props: Readonly<React.SVGProps<SVGSVGElement>>): JSX.Element {
  return (
    <svg width='11' height='13' viewBox='0 0 11 13' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2.5 6.16667V7.83333M2.5 6.16667V2.16667C2.5 1.61438 2.94772 1.16667 3.5 1.16667C4.05228 1.16667 4.5 1.61438 4.5 2.16667M2.5 6.16667C2.5 5.61438 2.05228 5.16667 1.5 5.16667C0.947715 5.16667 0.5 5.61438 0.5 6.16667V7.5C0.5 10.2614 2.73858 12.5 5.5 12.5C8.26142 12.5 10.5 10.2614 10.5 7.5V4.16667C10.5 3.61438 10.0523 3.16667 9.5 3.16667C8.94772 3.16667 8.5 3.61438 8.5 4.16667M4.5 2.16667V5.83333M4.5 2.16667V1.5C4.5 0.947715 4.94772 0.5 5.5 0.5C6.05229 0.5 6.5 0.947715 6.5 1.5V2.16667M6.5 2.16667V5.83333M6.5 2.16667C6.5 1.61438 6.94772 1.16667 7.5 1.16667C8.05229 1.16667 8.5 1.61438 8.5 2.16667V4.16667M8.5 4.16667V5.83333'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
